import { atom } from "recoil"

export const AtomBalanceRP = atom({
    key:'ATOMBALANCERP',
    default:''
})
  